<template>
  <content-loader :height="82" :width="460">
    <rect x="0" y="0" rx="8" ry="8" width="224" height="48" />
    <rect x="236" y="0" rx="8" ry="8" width="224" height="48" />
    <rect x="0" y="64" rx="2" ry="2" width="160" height="10" />
  </content-loader>
</template>

<script>
import ContentLoader from '@/components/contentLoaders/ContentLoader'

export default {
  components: {
    ContentLoader,
  },
}
</script>
